var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7321 15C9.96225 16.3333 8.03775 16.3333 7.26795 15L0.339748 3C-0.430052 1.66667 0.5322 -1.78935e-06 2.0718 -1.65476e-06L15.9282 -4.43391e-07C17.4678 -3.08794e-07 18.4301 1.66667 17.6603 3L10.7321 15Z",
    fill: "#DC2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleBottom);
export default __webpack_public_path__ + "static/media/triangleBottom.879b33041cfe6606180409bee558bffd.svg";
export { ForwardRef as ReactComponent };